import request from '@/utils/request'

// 查询短信记录列表
export function listRecord(query) {
  return request({
    url: '/sms/record/list',
    method: 'get',
    params: query
  })
}

// 发送验证码
export function sendSmsCaptchaCode(username) {
  return request({
    url: '/sms/record/sendSmsCaptchaCode/' + username,
    method: 'get'
  })
}

// 重发
export function retry(id) {
  return request({
    url: '/sms/record/retry/?id=' + id,
    method: 'get'
  })
}

// 查询接收状态
export function reportStat(id) {
  return request({
    url: '/sms/record/reportStat/?id=' + id,
    method: 'get'
  })
}
